import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { trackVisit } from "@/lib/track";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CandleProvider } from "@/lib/candle";
import TopBar from "@/components/TopBar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import AudioBar from "@/components/AudioBar";
import Story from "@/components/Story";
import Tree from "@/components/Tree";
import Program from "@/components/Program";
import Gallery from "@/components/Gallery";
import Footer from "@/components/Footer";
import BottomNav from "@/components/BottomNav";
import Admin from "@/components/Admin";
import GalleryPage from "@/components/GalleryPage";
import AdminMediaPage from "@/components/media/AdminMediaPage";
import DocumentsPage from "@/components/documents/DocumentsPage";
import AdminDocumentsPage from "@/components/documents/AdminDocumentsPage";

function Memorial() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <CandleProvider>
      <div className="min-h-screen overflow-x-clip bg-[#FAF8F5] text-stone-800 antialiased">
        <TopBar />
        <div
          data-testid="page-watermark"
          aria-hidden="true"
          className="pointer-events-none fixed inset-0 z-0"
        >
          <img
            src="/images/portrait.jpg"
            alt=""
            className="absolute right-[-8%] top-[12%] h-[65vh] w-[65vh] rounded-full object-cover object-top opacity-[0.06] grayscale"
          />
          <img
            src="/images/portrait.jpg"
            alt=""
            className="absolute bottom-[6%] left-[-10%] h-[55vh] w-[55vh] rounded-full object-cover object-top opacity-[0.05] grayscale"
          />
        </div>
        <main className="relative z-[1]">
          <Hero />
          <Marquee />
          <AudioBar />
          <Story />
          <Tree />
          <Program />
          <Gallery />
        </main>
        <Footer />
        <BottomNav />
        <Toaster position="top-center" richColors />
      </div>
    </CandleProvider>
  );
}

function VisitTracker() {
  const location = useLocation();
  useEffect(() => {
    trackVisit(location.pathname);
  }, [location.pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <VisitTracker />
      <Routes>
        <Route path="/" element={<Memorial />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/admin/medias" element={<AdminMediaPage />} />
        <Route path="/admin/documents" element={<AdminDocumentsPage />} />
        <Route path="/documents" element={<DocumentsPage />} />
        <Route path="/galerie" element={<GalleryPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
